<template>
  <v-container 
    class="py-3"
    fluid
  >
    <base-material-card
      color="primary"
      icon="mdi-file-cog"
      inline
      class="px-5 py-4 ml-0"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Manutenção de Mapeamentos 
        </div>
      </template>
      <v-text-field
        id="mapeamentos-search"
        v-model="search"
        append-icon="mdi-magnify"
        label="Procurar"
        hide-details
        single-line
      />
      <v-divider class="mt-10" />
      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :mobile-breakpoint="800"
        no-data-text="Nenhum Mapeamento disponível"
        :loading="loading"
        loading-text="Carregando..."
      >
        <template v-slot:[`item.importacaoUsuario`]="{ item }">
          <span class="importacao-usuarios" style="color:#3fa6f4" v-if="item.importacao_usuarios">
            Disponível
          </span>
          <span class="importacao-usuarios" style="color:red" v-else>
            Indisponível
          </span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-remover-mapeamento"
            @click="openDialogDelete(item.id, item.nome)"
            min-width="0"
            class="px-1 ml-n1"
            fab
            icon
            x-small
          >
            <v-icon small>mdi-trash-can-outline</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="actions-mapeamento"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>
                  mdi mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="openDialogReplicar(item)">
                <v-list-item-title>
                  <v-icon small>
                    mdi-autorenew
                  </v-icon>
                  Replicar
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="item.importacao_usuarios == true && loadingItem != true"
                @click="importacaoUsuarios(item.id)"
              >
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-thumb-down</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  Tornar Indisponível
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="item.importacao_usuarios == false && loadingItem != true"
                @click="importacaoUsuarios(item.id)"
              >
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-thumb-up</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  Tornar Disponível
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="loadingItem">
                <v-list-item-icon>
                  <v-progress-circular
                    color="#757575"
                    indeterminate
                    :size="20"
                  />
                </v-list-item-icon>
              </v-list-item>
              <v-list-item @click="openDialogEdit(item)">
                <v-list-item-title>
                  <v-icon small>
                    mdi-pencil
                  </v-icon>
                  Editar
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDialogDetalhes(item)">
                <v-list-item-title>
                  <v-icon small>
                    mdi-file-find-outline
                  </v-icon>
                  Detalhes
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="dialogCreationLog = true, dialogCreationLogData = {username: item.usuario.nome, created: item.created}"
              >
                <v-list-item-title>
                  <v-icon medium>
                    mdi-table-search
                  </v-icon>
                  Log
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-creation-log
      :dialog.sync="dialogCreationLog"
      :item="dialogCreationLogData"
    />
    <general-dialog-detalhes
      ref="dialogDetalhes"
      title="Detalhes do Mapeamento"
      maxWidth="70%"
      :showDialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          :headers="dialogDetalhesHeader"
          :items="dialogDetalhesData"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes pt-2"
          disable-pagination
          mobile-breakpoint="10"
        />
      </template>
    </general-dialog-detalhes>
    <dialog-edit-mapeamento
      :showDialog.sync="showDialogEdit"
      :items="itemsEdit"
      @reloadItemsTabela="$emit('reloadItemsTabela')"
    />
    <dialog-replicar 
      :showDialog.sync="showDialogReplica"
      :items="itemMapeamento"
    />
    <dialog-delete 
      :showDialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarItem(dialogDeleteData.id)"
    >
      <template slot="title">
        <span style="word-break: break-word">Deletar Mapeamento #{{dialogDeleteData.id}}</span>
      </template>
      <template slot="body">Tem certeza que deseja deletar Mapeamento <strong>{{ dialogDeleteData.titulo }}</strong>?</template>
    </dialog-delete>
  </v-container>
</template>
<script>
import Mapeamento from '@/services/MapeamentoService.js';

export default {
  components: {
  	DialogCreationLog: () => import('@/components/general/DialogCreationLog'),
    GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes'),
    DialogDelete: () => import('@/components/general/DialogDelete'),
    DialogEditMapeamento: ()=> import('@/components/mapeamentos/DialogEditMapeamento'),
    DialogReplicar: ()=> import('@/components/mapeamentos/DialogReplicar')
  },

  props: {
    items: {
      type: Array,
      required: true
    },
    loading:{
      type: Boolean,
      required: true
    }
  },

  data: () => ({
    search:'',
    itemsEdit:{},
    itemMapeamento:{},
    dialogDelete:false,
    loadingItem: false,
    dialogDetalhesData:[],
    dialogDetalhes: false,
    showDialogEdit: false,
    dialogCreationLog: false,
    showDialogReplica: false,
    dialogCreationLogData: {},   
    powerupService: Mapeamento,
    powerupEntityName: 'Manutenção de Mapeamentos',
    dialogDeleteData: {id: undefined, titulo: undefined},   
    dialogDetalhesHeader:[
      {
        text: 'COLUNA x CAMPO',
        value: 'nome'
      },
      {
        text: 'TIPO',
        value: 'tipo'
      },
      {
        text: 'FORMATO',
        value: 'formato'
      },
      {
        text: 'MÁSCARA',
        value: 'mascara'
      },
    ],
    headers: [
      {
        text: '#',
        value: 'id'
      },
      {
        text: 'Nome do Mapeamento',
        value: 'nome'
      },
      {
        text: 'Tipo de Importação',
        value: 'tipos_importacoes.descricao'
      },
      {
        text: 'Importação de Usuários?',
        value: 'importacaoUsuario',
        sortable: false,
      },
      {
        sortable: false,
        text: "Ações",
        value: "actions",
        align: 'center'
      }
    ]
  }),

  methods:{
    importacaoUsuarios(id) {
      this.loadingItem = true;
      Mapeamento.importacaoUsuarios(id)
      .then(() => {
        this.$emit('reloadItemsTabela');
      })
      .catch(error => {
        console.error(error);
        this.$toast.error('Erro ao alterar campo de importacao Usuarios.', '',{position:'topRight'});
      })
      .finally(() => this.loadingItem = false);
    },

    openDialogDetalhes(items) {  
      this.dialogDetalhesData = [];
      items.pre_mapeamentos_importacao.forEach(item => {
        var objItem =  {
          nome: item.coluna_arquivo + ' x ' + item.campo_sistema.campo_sistema_descricao,
          tipo: item.coluna_arquivo_tipo_dados,
          formato: item.coluna_arquivo_formato_dados,
          mascara: item.coluna_arquivo_mascara
        };        
        this.dialogDetalhesData.push(objItem);
      });
      this.dialogDetalhes = true;
    },

    openDialogEdit(items){
      this.showDialogEdit = true
      this.itemsEdit = items
    },

    openDialogReplicar(items){
      this.showDialogReplica = true
      this.itemMapeamento = items
    },

    openDialogDelete(id, titulo) {
      this.dialogDeleteData = {id: id, titulo: titulo};
      this.dialogDelete = true;
    },
    
    deletarItem(id){
      Mapeamento.deletarMapeamento([id])
      .then(() => {
        this.$emit('reloadItemsTabela');
        this.dialogDelete = false;
      })
      .catch(error => {
        console.error(error);
        this.$toast.error('Erro ao remover mapeamento.', '',{position:'topRight'});
      })
      .finally(() => this.loadingItem = false);
    }
  }
}
</script>
<style>
  .importacao-usuarios {
    font-size: 0.95rem !important;
    font-weight: normal !important;
  }
</style>